import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateHeader from "../../../../components/common/layout/CorporateHeader";
import Banner from "../../../../components/corporate/corporate/aboutMMRC/Banner";
import VisionMission from "../../../../components/corporate/corporate/aboutMMRC/VisionMission";
import DrivesUs from "../../../../components/corporate/corporate/aboutMMRC/DrivesUs";
import QuickLinks from "../../../../components/corporate/corporate/aboutMMRC/QuickLinks";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";

const AboutMMRC = () => {
    const { t } = useTranslation('common');
    useSitemap();

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.about_mmrc.title")}</title>
                <meta name="description" content={t("seo_friendly.about_mmrc.desc")} />
            </Helmet>

            <div className="dark:bg-bgDarkDull bg-white w-full h-full">
                <CorporateHeader />

                <div id="home" className="pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px] w-full">
                    <Banner />
                    <VisionMission />
                    <DrivesUs />
                    <QuickLinks />
                </div>
            </div>
        </>
    );
};

export default AboutMMRC;